import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
    DataGrid,
    GridColDef,
    GridToolbar,
    // GridColumnVisibilityModel,
    // GridColTypeDef,
    GridValueFormatterParams
} from "@mui/x-data-grid";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getPatients } from "../services/get.service";
import { patient, user } from "../common/type";
import ClipLoader from "react-spinners/ClipLoader";

const Patient = (props: {user: user | null}) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [rows, setRows] = useState<Array<patient>>([])
    const { user } = props

    useEffect(() => {
        setLoading(true);

        getPatients()
            .then((res) => {
                setLoading(false);
                setRows(res.data)
            })
            .catch((err) => {
                setLoading(false)
                console.log(err)
            })
    }, [setRows]);

    const columns: GridColDef[] = [
        { field: 'cardNo', headerName: "Card No", width: 170 },
        { field: 'firstName', headerName: "First Name", width: 170 },
        { field: 'middleName', headerName: "Middle Name", width: 170 },
        { field: 'lastName', headerName: "Last Name", width: 170 },
        { field: 'gender', headerName: "Gender", width: 170 },
        {
            field: 'dateOfBirth', headerName: "Date of Birth", width: 170, type: "dateTime", valueFormatter: (val: GridValueFormatterParams<Date>) => {
                return new Date(val.value).toDateString()
            }
        },
        {
            field: 'createdAt', headerName: "Registered Date", width: 170, type: "dateTime", valueFormatter: (val: GridValueFormatterParams<Date>) => {
                return new Date(val.value).toDateString()
            }
        },
        { field: 'phoneNumber', headerName: "Phone Number", width: 170 },
        { field: 'branchName', headerName: "Branch", width: 170 }
    ]

    return <>
        <Helmet>
            <title>Patients</title>
        </Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full lg:px-20 px-3 py-10 pt-5">
                    {user?.roles.some((r) => r.name === "Admin" || r.name === "Doctor" || r.name === "Cashier") && <Button variant="contained">
                        <Link to="/create/patient">Add New</Link>
                    </Button>}
                    <Typography variant="h4" fontSize={32} className="py-3">Patients</Typography>
                    <Box sx={{ height: 520, width: "100%" }}>
                        {loading ?
                            (
                                <ClipLoader loading={loading} size={70} />
                            )
                            :
                            (
                                rows !== undefined && rows.length > 0 ?
                                    (
                                        <DataGrid rows={rows} onRowClick={(r) => console.log(r.id)
                                        } columns={columns} slots={{ toolbar: GridToolbar }} />
                                    )
                                    :
                                    <DataGrid rows={[]} columns={columns} />
                            )
                        }
                    </Box>
                </div>
            </div>
        </div>
    </>;
};

export default Patient;
